import { Component, Vue, Prop } from 'vue-property-decorator';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

library.add(faTimesCircle);

@Component({
	components: {
	},
})
export default class InputPortal extends Vue {
	@Prop({ default: 'Erro.' }) readonly text;
}
